"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
require("../tabs.css");
var _excluded = ["children", "className", "inactiveTabClassName", "innerLine", "isActive", "onClick", "parentId", "sliderClassName", "style", "tabId"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A `Tab` should be placed as an immediate descendant of a `TabList`.
 *
 * Only one `Tab` is active at a time, and it controls the visible content of the nearby `TabPanelList`.
 *
 * The number of `Tab` elements should match that of the `TabPanel` elements within a `Tabs` component.
 *
 * **Note that only the props listed below should be modified, as this component is controlled by `TabList`.**
 */
var Tab = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    className = props.className,
    inactiveTabClassName = props.inactiveTabClassName,
    innerLine = props.innerLine,
    isActive = props.isActive,
    onClick = props.onClick,
    parentId = props.parentId,
    sliderClassName = props.sliderClassName,
    style = props.style,
    tabId = props.tabId,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement("button", _extends({
    "aria-controls": "".concat(parentId, "-tabpanel-").concat(tabId),
    "aria-selected": isActive,
    className: (0, _classnames["default"])('position-relative sb-tabs--tab', _defineProperty(_defineProperty(_defineProperty({}, inactiveTabClassName, !isActive && inactiveTabClassName), 'px2 pt2 pb3 items-center flex-grow size12of12', !className), className, className)),
    id: "".concat(parentId, "-tab-").concat(tabId),
    onClick: onClick,
    ref: ref,
    role: "tab",
    style: style,
    tabIndex: isActive ? undefined : -1
  }, otherProps), children, innerLine ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_defineProperty({
      'sb-tabs--slider': isActive
    }, sliderClassName, sliderClassName && isActive)),
    id: "".concat(parentId, "-slider-inside-").concat(tabId)
  }) : null);
});
Tab.displayName = 'Tab';
Tab.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Any child elements can be passed into the `Tab`. Child elements will be wrapped within the `Tab`'s inner `button` element.
   */
  children: _propTypes["default"].node,
  /**
   * This class is assigned to the inner `button` element of the `Tab`.
   */
  className: _propTypes["default"].string,
  /**
   * Styling applied to the inner `button` element of the `Tab`.
   */
  style: _propTypes["default"].object
} : {};
var _default = exports["default"] = Tab;